import React, { FunctionComponent } from 'react';

import { SettingsEnableDisable } from '@components/settings/shared/settings-enable-disable';

interface ShowCustomFieldsProps {
  defaultEnabled: boolean | null;
}

const ShowCustomFields: FunctionComponent<ShowCustomFieldsProps> = ({ defaultEnabled }) => (
  <SettingsEnableDisable
    defaultEnabled={defaultEnabled === null ? true : defaultEnabled}
    description={bfTranslate('Only applies to assets in Collections and Share Links')}
    errorTitle={bfTranslate('Error updating Custom Field viewing permissions. Please contact support.')}
    id="show-custom-fields"
    successTitle={bfTranslate('Custom Field viewing permissions updated!')}
    title={bfTranslate('Allow guests and public users to see Custom Fields')}
    updateResourceKey="showCustomFieldsOverviewTab"
  />
);

export default ShowCustomFields;
